import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    forgotPasswordOuterContainer: {
      height: '640px',
      background: '#D8D8D8',
      color: '#2A2A2A',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      margin: '0px 72px 80px 72px',
      overflow: 'hidden',
      borderRadius: '8px',
      width: 'auto !important',
      [theme.breakpoints.only('md')]: {
        height: '750px !important'
      },
      [theme.breakpoints.down('md')]: {
        height: '100%',
        margin: '0px 0px 40px 0px'
      },
      [theme.breakpoints.only('sm')]: {
        margin: '0px 16px 40px 16px'
      },
      [theme.breakpoints.only('xs')]: {
        margin: '0px 16px 0px 16px'
      }
    },
    forgotPasswordImageBlock: {
      width: '50%',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%'
      }
    },
    forgotPasswordViewBlock: {
      background: 'white',
      color: '#2A2A2A',
      padding: '96px 72px 96px 40px',
      width: '50%',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%'
      },
      [theme.breakpoints.down('xs')]: {
        padding: '24px 32px 27px 32px'
      }
    },
    forgotPasswordTextBox: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 24px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0px 10px 0px'
      }
    },
    forgotPasswordHeader: {
      lineHeight: '1.1 !important',
      fontWeight: 600,
      fontSize: '50px !important',
      margin: '0px !important',
      letterSpacing: 'normal !important',
      [theme.breakpoints.only('sm')]: {
        fontSize: '40px !important'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '24px !important'
      }
    },
    forgotPasswordTextBorder: {
      background: 'transparent',
      margin: '40px 40px 40px 40px',
      [theme.breakpoints.only('xs')]: {
        margin: '6px 40px 0px 40px'
      }
    },
    forgotPasswordSubHeader: {
      fontWeight: 500,
      fontSize: '14px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.only('xs')]: {
        fontSize: '18px'
      }
    },
    forgotPasswordEmailInput: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 32px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0px 24px 0px'
      },
      // changing the style of textfield
      '& > * > *': {
        [theme.breakpoints.only('xs')]: {
          height: '37px',
          marginBottom: '0px'
        }
      }
    },
    forgotPasswordSendEmailButton: {
      width: '334px',
      height: '69px',
      fontSize: '24px',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        height: '49px',
        fontSize: '18px'
      }
    },
    PasswordResetEmailBlock: {
      background: 'white',
      color: '#2A2A2A',
      padding: '96px 72px 96px 40px',
      [theme.breakpoints.down('sm')]: {
        padding: '24px 30px 30px 30px'
      }
    },
    passwordResetHeader: {
      lineHeight: '1.1',
      fontWeight: 600,
      fontSize: '50px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.only('sm')]: {
        fontSize: '40px'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '24px'
      }
    },
    passwordResetDivider: {
      flex: '1 1 0%',
      background: 'transparent',
      margin: '40px 40px 40px 40px',
      [theme.breakpoints.only('xs')]: {
        margin: '6px 0px 0px 0px'
      }
    },
    passwordResetSubHeader: {
      fontWeight: 500,
      fontSize: '14px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.only('xs')]: {
        fontSize: '18px'
      }
    }
  })
);
